import { render, staticRenderFns } from "./UpdatesModal.vue?vue&type=template&id=51273bd4"
import script from "./UpdatesModal.vue?vue&type=script&lang=js"
export * from "./UpdatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports